export const GdtMessageSegments: {
  id: string;
  description: string;
}[] = [
  { id: 'GDT3000', description: 'Patient number' },
  { id: 'GDT3101', description: 'Last name' },
  { id: 'GDT3102', description: 'First name' },
  { id: 'GDT3103', description: 'Date of Birth' },
  { id: 'GDT3105', description: 'Insurance number' },
  { id: 'GDT3106', description: 'Postcode' },
  { id: 'GDT3107', description: 'Address' },
  { id: 'GDT3110', description: 'Sex' },
  { id: 'GDT3618', description: 'Mobile phone' },
  { id: 'GDT3619', description: 'Email' },
  { id: 'GDT3626', description: 'Home phone' },
  { id: 'GDT8315', description: 'Receiver' },
  { id: 'GDT9070', description: 'Health insurance company ID' },
  { id: 'GDT6333', description: 'Visit start date' },
  { id: 'GDT6335', description: 'Visit start time' },
  { id: 'GDT6337', description: 'Visit duration' },
  { id: 'GDT6339', description: 'Visit type' },
  { id: 'GDT6341', description: 'Visit comment' },
];
